import React, { Component, Fragment } from 'react';
import SwipeBox from 'fslightbox-react';

// Old photos (/assets/img/1.jpg ... 9.jpg) kept on disk; only 1, 5, 8 still published
const images = [
    '/assets/img/gallery/1.jpg',
    '/assets/img/gallery/2.jpg',
    '/assets/img/gallery/3.jpg',
    '/assets/img/gallery/4.jpg',
    '/assets/img/gallery/5.jpg',
    '/assets/img/gallery/6.jpg',
    '/assets/img/gallery/7.jpg',
    '/assets/img/gallery/8.jpg',
    '/assets/img/1.jpg',
    '/assets/img/5.jpg',
    '/assets/img/8.jpg',
];

class SwipeBoxComponent extends Component {
    state = {
        isVisible: false,
        slide: 0,
    };
    showSlide = (slide, event) => {
        event.preventDefault();
        this.setState({
            isVisible: !this.state.isVisible,
            slide: slide
        });
    };

    render() {
        return (
            <Fragment>
                <SwipeBox
                    toggler={this.state.isVisible}
                    slide={this.state.slide}
                    sources={images}
                />

                {images.map((src, index) => (
                    <div key={src} className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <a onClick={(event) => this.showSlide(index + 1, event)} title={`Foto ${index + 1}`} className="gallery-item swipebox" href={src} rel="gallery">
                            <div className="img object-fit">
                                <div className="object-fit-cover">
                                    <img src={src} alt={`Foto ${index + 1}`} />
                                </div>
                            </div>

                            <div className="img-bg-color"></div>
                        </a>
                    </div>
                ))}
            </Fragment>
        );
    }
}

export default SwipeBoxComponent;
